import { render, staticRenderFns } from "./WtTabs.vue?vue&type=template&id=7ccf8818&scoped=true"
import script from "./WtTabs.vue?vue&type=script&lang=js"
export * from "./WtTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccf8818",
  null
  
)

export default component.exports